import React from 'react';
import Card from '@material-ui/core/Card';
import authProvider from '../authProvider';
import CardContent from '@material-ui/core/CardContent';
import Link from '@material-ui/core/Link';
import { FormDataConsumer, BooleanInput, SelectInput, SimpleForm, DateInput, ReferenceArrayInput, 
  AutocompleteArrayInput, SelectArrayInput, Button } from 'react-admin';
import Highcharts from 'highcharts';
import { DisclaimerComponent } from '../components/disclaimer.js';
import DashboardTopSitesComponent from './dashboard_topsites';
import DashboardTopBiddersComponent from './dashboard_topbidders';
import DashboardOptimizerPredictiveAnalysisComponent from './dashboard_optimizer_pred_analysis';
import MarketMoversAnalysisComponent from './dashboard_marketmoversanalysis';
import AdstxtAnalysisComponent from './dashboard_adstxt_analysis';
import RunReportIcon from '@material-ui/icons/PlayCircleFilledRounded';
import { AlertComponent } from '../components/alerts.js';
import Tooltip from '@material-ui/core/Tooltip';
import MIButton from '@material-ui/core/Button';
const ReactHighcharts = require('react-highcharts');
const utils = require('../components/utils');

const prebidBidders = require('../prebidBidderModules.json');
const otherBidders = require('../carbonOtherBidders.json');
function prebidAndOtherBidders () {
  let ret = [{id: '', name: '--- PREBID ---', disabled: true},...prebidBidders];
  ret.push({id: '', name: '--- OTHER ---', disabled: true});
  ret = ret.concat(otherBidders);
  return ret;
};
const selectableBidders = prebidAndOtherBidders();

const DEFAULT_DATE_RANGE = 30;
const isAdmin = function (role) {
  return ['admin', 'report_admin', 'advertiser'].includes(role);
}
const REVENUE_COLOR = '#49b27b';
const GROSS_REVENUE_COLOR = '#adff2f';
const CPM_COLOR = '#f02d5b';
const IMPRESSIONS_COLOR = '#009fdb';
const BORDER_COLOR = '#666666';

function colorValue(v) {
  return (v >= 0) ? 'white' : 'white';
}
const styleSummaryTitle = {
  textAlign: 'center',
  fontSize: '12px',
  fontWeight: '200',
  color: 'white',
  paddingTop: '15px'
}
const styleSummary = {
  textAlign: 'center',
  fontSize: '16px',
  overflow: 'hidden',
  fontWeight: '400'
}
const styleArrowDown = {
  width: 0,
  height: 0,
  borderStyle: 'solid',
  borderWidth: '10px 5px 0 5px',
  borderColor: '#f02d5b transparent transparent transparent',
  float: 'left',
  margin: '0 5px',
  marginTop: '0px'
}
const styleArrowUp = {
  width: 0,
  height: 0,
  borderStyle: 'solid',
  borderWidth: '0 5px 10.4px 5px',
  borderColor: 'transparent transparent #49b27b transparent',
  float: 'left',
  margin: '0 5px',
  marginTop: '0px'
};
/**
 *         total_number_of_data*sum(x*y) - sum(x)*sum(y)
 * slope = --------------------------------------------------
 *         total_number_of_data*sum(x*x) - sum(x)*sum(x)
 *  
 * Ref: https://www.wolframalpha.com/input/?i=linear%20regression
 *         
 * @param x
 * @returns
 */
function linearRegression(y) {
  const total = y.length
  let i = 1
  let x = []
  let sumx = 0
  let sumy = 0
  let sumxy = 0
  let sumxx = 0
  y.map(v => {
    x.push(i)
    sumy += v
    sumx += i
    sumxy += i * v
    sumxx += i * i
    i++
  })

  let num = total * sumxy - sumx * sumy
  let den = total * sumxx - sumx * sumx

  let slope = num / den
  let intercept = (sumy - slope * sumx) / total;

  return { slope: slope, intercept: intercept };
}

const dateRangeChoices = [
  { id: '0', name: 'Today' },
	{ id: 1, name: 'Yesterday' },
	{ id: 2, name: 'Last 2 Days' },
	{ id: 3, name: 'Last 3 Days' },
  { id: 5, name: 'Last 5 Days' },
	{ id: 7, name: 'Last 7 Days' },
	{ id: 8, name: 'Last 8 Days' },
	{ id: 10, name: 'Last 10 Days' },
  { id: 15, name: 'Last 15 Days' },
	{ id: 30, name: 'Last 30 Days' },
  { id: 'lm', name: 'Last Month' },
  { id: 'mtd', name: 'Month to Date' },
  { id: 'mty', name: 'Month to Yesterday' },
  { id: 'ytd', name: 'Year to Date' },
  { id: 'yty', name: 'Year to Yesterday' },
	{ id: 'custom', name: 'Custom' }
];

const choicesInterval = [
  { id: 'day', name: 'Daily' },
  { id: 'week', name: 'Weekly' },
  { id: 'month', name: 'Monthly' },
  { id: 'year', name: 'Yearly' }
];

const choicesDevices = [
  { id: 'Computer', name: 'Desktop' },
  { id: 'Mobile', name: 'Mobile' },
  { id: 'Tablet', name: 'Tablet' }
]

const choicesAdType = [
  { id: 'banner', name: 'BANNER' },
  { id: 'native', name: 'NATIVE' },
  { id: 'video', name: 'VIDEO' }
]
var config = {
  chart: {
    id: 'DashboardChart',
    renderTo: 'container',
    zoomType: 'x',
    height: '25%',
    backgroundColor: 'none',
    borderColor: BORDER_COLOR,
    borderWidth: 1,
  },
  title: {
    text: 'Publisher Earnings',
    style: {
      color: '#ffffff',
      fontWeight: 'bold',
      fontFamily: 'Roboto, Helvetica, Arial, sans-serif'
    }
  },
  subtitle: { text: 'Source: NoBid Inc.' },
  xAxis: {
    type: 'datetime',
    labels: {
      format: '{value:%e-%b-%y}',
      style: {
        color: '#ffffff',
        fontFamily: 'Roboto, Helvetica, Arial, sans-serif'
      }
    },
    crosshair: true
  },
  yAxis: [{
    labels: {
      format: '${value}',
      style: {
        color: '#ffffff',
        fontFamily: 'Roboto, Helvetica, Arial, sans-serif'
      }
    },
    title: {
      text: 'Revenue ($)',
      style: {
        color: '#ffffff',
        fontWeight: 'bold',
        fontFamily: 'Roboto, Helvetica, Arial, sans-serif'
      }
    },
    plotLines: [{
      value: 0,
      width: 4
    }],
    min: 0
  }, {
    labels: {
      style: {
        color: '#ffffff',
        fontFamily: 'Roboto, Helvetica, Arial, sans-serif'
      }
    },
    title: {
      text: 'Impressions',
      style: {
        color: '#ffffff',
        fontWeight: 'bold',
        fontFamily: 'Roboto, Helvetica, Arial, sans-serif'
      }
    },
    opposite: true,
    min: 0
  }, {
    labels: {
      format: '${value}',
      style: {
        color: '#ffffff',
        fontFamily: 'Roboto, Helvetica, Arial, sans-serif'
      }
    },
    title: {
      text: 'Avg CPM ($)',
      style: {
        color: '#ffffff',
        fontWeight: 'bold',
        fontFamily: 'Roboto, Helvetica, Arial, sans-serif'
      }
    },
    opposite: false,
    min: 0
  }],
  series: [
    {
      name: 'Impressions',
      shadow: true,
      color: IMPRESSIONS_COLOR,
      yAxis: 1
    },
    {
      name: 'Revenue',
      type: 'column',
      borderRadius: 1,
      fillOpacity: 0.5,
      shadow: true,
      animation: Highcharts.svg,
      marginRight: 10,
      color: REVENUE_COLOR,
      valuePrefix: '$',
      tooltip: { valuePrefix: '$', valueSuffix: ' USD' },
      borderWidth: 0,
      yAxis: 0
    },
    {
      name: 'Avg CPM',
      type: 'spline',
      shadow: true,
      animation: Highcharts.svg,
      marginRight: 10,
      color: CPM_COLOR,
      valuePrefix: '$',
      tooltip: { valuePrefix: '$', valueSuffix: ' USD' },
      borderWidth: 0,
      yAxis: 2
    }
  ],
  legend: {
    itemStyle: {
      color: '#ffffff',
      fontWeight: 'bold',
      fontFamily: 'Roboto, Helvetica, Arial, sans-serif'
    }
  }
};

var globalRole = 'publisher';
const FormToolbar = props => (<span></span>);
const BASE_URL = window.nobid_endpoint + '/carbon/pubreports_report?show=date&show=revenue&show=impressions&show=avg_cpm&'
const yesterday = new Date(new Date().getTime() - (3600 * 1000 * 24));
const endDate = yesterday.toISOString().substring(0, (new Date()).toISOString().indexOf('T'));
let prev = new Date(new Date().getTime() - (30 * 24 * 60 * 60 * 1000));
prev = prev.toISOString().substring(0, (new Date()).toISOString().indexOf('T'));
class CarbonDashboard extends React.Component {
  state = {
    loading: true,
    params: ['_end=1000000', '_order=ASC', '_sort=id', '_start=0', `date_range=${DEFAULT_DATE_RANGE}`],
    baseUrl: BASE_URL
  };
  constructor(permissions, props) {
    permissions.authProvider.getPermissions().then(({role}) => {
      globalRole = role;
    })
    super(props)
    this.state.loading = true
  }
  updateState(results) {
    function roundVal(v, decimals) {
      decimals = (decimals) ? decimals + 1 : 3
      v = '' + v
      v = (v.indexOf('.')) ? ('' + v).substring(0, ('' + v).indexOf('.') + decimals) : v
      return Number(v)
    }
    let imps = [];
    let revs = [];
    let grev = [];
    let cpms = [];
    let totalRev = 0;
    let totalImp = 0;
    let lrimps = [];
    let lrrevs = [];
    let lrcpms = [];
    if (results && results.length > 0) for (let i in results) {
      let d = '' + results[i].date;
      if (d.indexOf('T') > 0) d = d.substring(0, d.indexOf('T'));
      let rev = roundVal(results[i].revenue);
      let s = { x: (new Date(d)).getTime(), y: rev }
      totalRev += rev;
      lrrevs.push(rev);
      revs.push(s);

      let imp = results[i].impressions;
      s = { x: (new Date(d)).getTime(), y: imp }
      totalImp += imp;
      lrimps.push(imp);
      imps.push(s);

      s = { x: (new Date(d)).getTime(), y: roundVal(results[i].avg_cpm, 3) }
      lrcpms.push(results[i].avg_cpm);
      cpms.push(s);

      s = { x: (new Date(d)).getTime(), y: roundVal(results[i].revenue) }
      grev.push(s);
    }
    let chart = this.refs.chart.getChart();
    let seriesImps = chart.series[0];
    let seriesRevs = chart.series[1];
    let seriesCpms = chart.series[2];
    seriesImps.setData(imps);
    seriesRevs.setData(revs);
    // if (isAdmin(globalRole)) {
    // }

    seriesCpms.setData(cpms);
    this.setState({ loading: false });

    let totals = this.refs.totals;
    totals.updateState({
      totalRevenue: totalRev,
      totalImpressions: totalImp,
      averageCPM: roundVal(1000 * totalRev / totalImp),
      slopeRevenue: linearRegression(lrrevs).slope,
      slopeImpressions: linearRegression(lrimps).slope,
      slopeCPM: linearRegression(lrcpms).slope,
      interceptRevenue: linearRegression(lrrevs).intercept,
      interceptImpressions: linearRegression(lrimps).intercept,
      interceptCPM: linearRegression(lrcpms).intercept,
      minRevenue: Math.min(...lrrevs),
      maxRevenue: Math.max(...lrrevs),
      minImpressions: Math.min(...lrimps),
      maxImpressions: Math.max(...lrimps),
      minCPM: Math.min(...lrcpms),
      maxCPM: Math.max(...lrcpms)
    })
  }
  fetchData() {
    let chart = this.refs.chart.getChart();
    chart.showLoading();
    chart.series.forEach(series => series.setData([]));
    this.setState({ loading: true });
    let url = `${this.state.baseUrl}${this.state.params.join('&')}`;
    let options = { headers: new Headers() };
    options.headers.set('accept', 'application/json');
    const token = localStorage.getItem('token');
    options.headers.set('Authorization', `Bearer ${token}`);
    fetch(url, options).then((response) => {
      return response.json();
    })
      .then((results) => {
        this.updateState(results);
      });
  }
  componentDidMount() {
    if (this.refs.chart) {
      this.fetchData();
    } else {
      window.setTimeout(this.fetchData, 3000);
    }
  }
  handlePublisherInputChanged = (value) => {
    return this.handleFilterChanged(value, 'publisher_id');
  }
  handleAdTypeInputChanged = (value) => {
    return this.handleFilterChanged(value.target.value, 'ad_type');
  }
  handleSiteInputChanged = (value) => {
    return this.handleFilterChanged(value, 'site_id');
  }
  handleBidderInputChanged = (value) => {
    return this.handleFilterChanged(value, 'bidder_name');
  }
  handleDeviceInputChanged = (value) => {
    return this.handleFilterChanged(value.target.value, 'device');
  }
  handleFilterChanged = (values, thekey) => {
    const key = thekey + '='
    this.state.params = this.state.params.filter(word => !word.startsWith(key));
    values.forEach(element => {
      this.state.params.push(key + element);
    })
  }
  handleInputChanged = (value) => {
    this.state.params = this.state.params.filter(word => !word.startsWith(value.target.name + '='));
    this.state.params.push(`${value.target.name}=${value.target.value}`);
  }
  handleDateRangeChanged = (value) => {
    this.state.params = this.state.params.filter(word => !word.startsWith(value.target.name + '='));
    this.state.params.push(`${value.target.name}=${value.target.value}`);
    this.setState({ dateRange: value.target.value });
  }
  handleRunReport = () => {
    this.fetchData();
  }

  render() {
    const { loading, data, total, dateRange } = this.state;
    const { permissions, formType, record } = this.props;
    return (

      <div>
        <AlertComponent />

        <SimpleForm toolbar={<FormToolbar />}>

          <div style={{ width: '100%', overflow: 'hidden' }}>

            <div style={{ float: 'left', overflow: 'hidden', display: 'flex', columnGap: '1em' }} id="wrapper2">
              <SelectInput label="Interval" source="interval" choices={choicesInterval} defaultValue='day' 
                disabled={loading} onChange={this.handleInputChanged}/>
              <div>
                <SelectInput label="Date Range" source="date_range"
                  onChange={this.handleDateRangeChanged}
                  choices={dateRangeChoices}
                  defaultValue={`${DEFAULT_DATE_RANGE}`}
                  disabled={loading} />
                <div style={{ float: 'right', paddingLeft: '5px', display: ('custom' !== dateRange) ? 'none' : 'block' }}>
                  <div style={{ float: 'left', paddingRight: '5px', display: ('custom' !== dateRange) ? 'none' : 'block' }}>
                    <DateInput label="Start Date" source="start_date" allowEmpty disabled={loading}
                      style={{ display: ('custom' !== dateRange) ? 'none' : 'block' }} 
                      onChange={this.handleInputChanged} />
                  </div>
                  <div style={{ float: 'left', display: ('custom' !== dateRange) ? 'none' : 'block' }}>
                    <DateInput label="End Date" source="end_date" allowEmpty disabled={loading}
                      style={{ display: ('custom' !== dateRange) ? 'none' : 'block' }} 
                      onChange={this.handleInputChanged} />
                  </div>
                </div>
              </div>
              
              <div>
              <Button label="Refresh Dashboard" onClick={this.handleRunReport} props={this.props} variant="contained"
                style={{marginTop: '18px', padding: '7px', width: '200px'}} color="primary" startIcon={<RunReportIcon />} disabled={loading}/>
              </div>
              
            </div>

            <div style={{ float: 'right', paddingRight: '5px', marginTop: '10px' }}>
              <BooleanInput source='showFilters' label="Show Filters"></BooleanInput>
            </div>

          </div>

          <FormDataConsumer>
            {({ formData, ...rest }) => formData.showFilters &&

              <div style={{ width: '100%', overflow: 'hidden' }}>

                <div style={{ float: 'left', paddingRight: '5px' }}>
                  <SelectArrayInput label="Devices"
                    source="device"
                    choices={choicesDevices}
                    onChange={this.handleDeviceInputChanged}
                    style={{ width: '200px' }}
                    disabled={loading} />
                </div>

                <div style={{ float: 'left', paddingRight: '5px' }}>
                  <SelectArrayInput label="Ad Type"
                    source="ad_type"
                    choices={choicesAdType}
                    onChange={this.handleAdTypeInputChanged}
                    style={{ width: '150px' }}
                    disabled={loading} />
                </div>

                <div style={{ float: 'left', paddingRight: '5px' }}>
                  <ReferenceArrayInput
                    source="publisher_id"
                    label="Publisher"
                    reference="publishers"
                    basePath="publishers"
                    perPage={15}
                    sort={{ field: 'name', order: 'ASC' }}
                    filterToQuery={searchText => ({ search_name: searchText })}
                    allowEmpty
                    onChange={this.handlePublisherInputChanged}
                    disabled={loading}>
                    <AutocompleteArrayInput disabled={loading} label="Publishers" optionText="name" optionValue="code" />
                  </ReferenceArrayInput>
                </div>

                <div style={{ float: 'left', paddingRight: '5px' }}>
                  <ReferenceArrayInput
                    source="site_id"
                    label="Site"
                    reference="sites"
                    basePath="sites"
                    perPage={20}
                    sort={{ field: 'name', order: 'ASC' }}
                    filterToQuery={searchText => utils.siteFormFilter(searchText, formData)}
                    allowEmpty
                    onChange={this.handleSiteInputChanged}
                    disabled={loading}>
                    <AutocompleteArrayInput disabled={loading} label="Sites (type site name)" optionValue="code"
                    optionText={utils.formatSiteName} />
                  </ReferenceArrayInput>
                </div>

                <div style={{ float: 'left', paddingRight: '5px' }}>
                <AutocompleteArrayInput label="Bidders" 
                      source="bidder_name" 
                      choices={selectableBidders}
                      disabled={loading}
                      onChange={this.handleBidderInputChanged}
                      fullWidth />
                </div>

              </div>

            }
          </FormDataConsumer>

          <hr style={{ width: '100%' }} />

          <SummaryComponent ref="totals" />
          
          <ReactHighcharts config={config} ref="chart" domProps={{ id: 'eaningReportChartId' }} style={{width: '100%'}} />

          <br/>
          <table style={{width: '100%'}}>
          <tr>
          <td style={{paddingRight: '20px', verticalAlign: 'top'}} colSpan={2}>
            <Card>
              <CardContent>
              <DashboardOptimizerPredictiveAnalysisComponent authProvider={authProvider} params={this.state.params} parentLoading={this.state.loading}/>
              </CardContent>
            </Card>
          </td>
          </tr>
          <tr>
          <td style={{paddingRight: '20px', width: '50%', verticalAlign: 'top'}}>
          <Card>
          <CardContent>
          <DashboardTopSitesComponent authProvider={authProvider} params={this.state.params} parentLoading={this.state.loading}/>
          </CardContent>
          </Card>
          </td>
          <td style={{width: '50%', verticalAlign: 'top'}}>
            <Card>
            <CardContent>
            <DashboardTopBiddersComponent authProvider={authProvider} params={this.state.params} parentLoading={this.state.loading}/>
            </CardContent>
            </Card>
          </td>
          </tr>
          <tr>
          <td style={{paddingRight: '20px', width: '50%', verticalAlign: 'top'}}>
            <Card>
              <CardContent>
              <MarketMoversAnalysisComponent authProvider={authProvider} params={this.state.params} parentLoading={this.state.loading}/>
              </CardContent>
            </Card>
          </td>
          <td style={{paddingRight: '20px', width: '50%', verticalAlign: 'top'}}>
            <Card>
              <CardContent>
              <AdstxtAnalysisComponent authProvider={authProvider} params={this.state.params} parentLoading={this.state.loading}/>
              </CardContent>
            </Card>
          </td>
          </tr>
          </table>

        </SimpleForm>
      </div>
    );
  }
}

class SummarySectionComponent extends React.Component {
  render() {
    return (
      <div style={{ float: 'left', width: '32%', paddingLeft: '15px' }}>

        <Card raised>
          <CardContent style={{ textAlign: 'center', fontSize: '37px', fontWeight: '600', color: this.props.color }}>
            <div style={{ textAlign: 'center', color: this.props.color, fontSize: '12px' }}>{this.props.title}</div>
            {this.props.value}
            <hr style={{ marginTop: '10px', marginBottom: '-15px' }} />

            <table width='100%'>
              <tbody>
              <tr>
                <td>
                  <div style={styleSummaryTitle}>
                    <Tooltip title={`Minimum ${this.props.tooltip} in the time range.`} arrow><MIButton>Min</MIButton></Tooltip>
                  </div>

                  <div id="w1" style={{color: colorValue(this.props.min), ...styleSummary}}>
                    <div id="w2" style={{ left: '50%', display: 'inline-block' }} >
                      {this.props.min}
                    </div>

                  </div>
                </td>

                <td>
                  <div style={styleSummaryTitle}>
                  <MIButton>
			<div style={(parseFloat(this.props.slope) >= 0) ? styleArrowUp : styleArrowDown}></div>
			</MIButton>
                  </div>
                </td>

                <td>
                  <div style={styleSummaryTitle}>
                    <Tooltip title={`Maximum ${this.props.tooltip} in the time range.`} arrow><MIButton>Max</MIButton></Tooltip>
                  </div>

                  <div id="w1" style={{color: colorValue(this.props.max), ...styleSummary}}>
                    <div id="w2" style={{ left: '50%', display: 'inline-block' }} >
                      {this.props.max}
                    </div>

                  </div>
                </td>

              </tr>

              </tbody>
            </table>

          </CardContent>
        </Card>

      </div>
    )
  }
}

class SummaryComponent extends React.Component {
  state = {
    loading: true,
    totalRevenue: 0,
    totalImpressions: 0,
    totalGrossImpressions: 0,
    averageCpm: 0,
    slopeRevenue: 0,
    slopeImpressions: 0,
    slopeCpm: 0,
    interceptRevenue: 0,
    interceptImpressions: 0,
    interceptCpm: 0,
    minRevenue: 0,
    minImpressions: 0,
    minCpm: 0,
    maxRevenue: 0,
    maxImpressions: 0,
    maxCpm: 0
  };
  constructor(permissions, props) {
    super(props)
    this.state.loading = true
  }
  updateState = (data) => {
    this.setState(data)
  }
  render() {
    const { loading, data } = this.state;
    return (

      <div style={{ width: '100%', overflow: 'hidden', paddingBottom: '10px', align: 'center' }} >

        <SummarySectionComponent
          title='TOTAL IMPRESSIONS'
          tooltip='impressions'
          color='white'
          value={(this.state.totalImpressions) ? new Intl.NumberFormat('en-US').format(this.state.totalImpressions) : "-"}
          min={(this.state.minImpressions) ? new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(this.state.minImpressions) : "-"}
          max={(this.state.maxImpressions) ? new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(this.state.maxImpressions) : "-"}
          slope={(this.state.slopeImpressions) ? new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(this.state.slopeImpressions) : "-"}
          intercept={(this.state.interceptImpressions) ? new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(this.state.interceptImpressions) : "-"}
        />

        <SummarySectionComponent
          title={isAdmin(globalRole) ? 'GROSS REVENUE' : 'TOTAL REVENUE'}
          tooltip='revenue'
          color='white'
          value={(this.state.totalRevenue) ? new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumSignificantDigits: 8 }).format(this.state.totalRevenue) : " "}
          min={(this.state.minRevenue) ? new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 2 }).format(this.state.minRevenue) : "-"}
          max={(this.state.maxRevenue) ? new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 2 }).format(this.state.maxRevenue) : "-"}
          slope={(this.state.slopeRevenue) ? new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(this.state.slopeRevenue) : "-"}
          intercept={(this.state.interceptRevenue) ? new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(this.state.interceptRevenue) : "-"}
        />

        <SummarySectionComponent
          title='AVERAGE CPM'
          tooltip='average CPM'
          color='white'
          value={(this.state.averageCPM) ? new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumSignificantDigits: 5 }).format(this.state.averageCPM) : " "}
          min={(this.state.minCPM) ? new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 2 }).format(this.state.minCPM) : "-"}
          max={(this.state.maxCPM) ? new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 2 }).format(this.state.maxCPM) : "-"}
          slope={(this.state.slopeCPM) ? new Intl.NumberFormat('en-US', { maximumFractionDigits: 8 }).format(this.state.slopeCPM) : "-"}
          intercept={(this.state.interceptCPM) ? new Intl.NumberFormat('en-US', { maximumFractionDigits: 8 }).format(this.state.interceptCPM) : "-"}
        />

      </div>
    )
  }
}

export default ({ permissions, ...props }) => (
  <div>

    <Card style={{ width: '100%' }} raised>
      <CardContent>
        <div style={{fontWeight: 'bolder'}}><Link href={'/#'}>Main Dashboard</Link><span style={{margin: '0 10px 0 10px'}}>|</span>Analytics Adapter Dashboard</div>
        <CarbonDashboard authProvider={authProvider} />
      </CardContent>
    </Card>

    <DisclaimerComponent />
  </div>

);